import {injectable} from 'inversify';

import type {ConferenceModel} from './Conference.model';

import {BaseController} from '../Base/Base.controller';

@injectable()
export class ConferenceController extends BaseController<ConferenceModel> {
  constructor() {
    super();
  }
}
